import {
    Button,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    VStack,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import RandomNumberProbability from './NoC/RandomNumberProbability';
import SimpleWalker from './NoC/SimpleWalker';
import MouseWalker from './NoC/MouseWalker';
import PerlinNoise from './NoC/PerlinNoise';
import Landscape from './NoC/Landscape';
import { RiArrowRightLine, RiArrowLeftLine } from "react-icons/ri"


const exercises = [
    <>
        <FormLabel>Random Number Distribution (stops @ 100 iterations)</FormLabel>
        <RandomNumberProbability />
    </>,
    <>
        <FormLabel>Simple Walker</FormLabel>
        <SimpleWalker />
    </>,
    <>
        <FormLabel>Mouse Walker (follows mouse 50%)</FormLabel>
        <MouseWalker />
    </>,
    <>
        <FormLabel>Perlin Noise</FormLabel>
        <PerlinNoise />
    </>,
    <>
        <FormLabel>Landscape using Perlin Noise</FormLabel>  
        <Landscape />
    </>
]

export const NatureOfCode: React.FC = () => {
    const [index, setIndex] = useState(0);

    return (
        <>
            <Heading mb={12}>Nature of Code</Heading>
            <Flex direction="column" px={{ md: 24, sm: 10 }} mb="10" alignItems="center">
                <Flex justifyContent="space-between" width="full" mb="10">
                    <Button colorScheme="teal" variant="outline" title="Previous Exercise" disabled={index === 0}
                        onClick={() => setIndex(i => i - 1)}>
                        <RiArrowLeftLine />&nbsp;Previous
                    </Button>
                    <Button colorScheme="teal" variant="outline" title="Next Exercise" disabled={index === exercises.length - 1}
                        onClick={() => setIndex(i => i + 1)}>
                        Next&nbsp;<RiArrowRightLine />
                    </Button>
                </Flex>

                <VStack>
                    <FormControl>
                        {exercises[index]}
                    </FormControl>
                </VStack>
            </Flex>
        </>
    );
};